// Routes can be entered with only a client id (e.g. location.exportClientId, or
// localStorage.clientId after a reload) while redux `viewingClient` still points at
// whoever was open before. Anything downstream that reads the client from redux instead
// of the id then works on the wrong client. Returns the client redux should switch to,
// or undefined when it is already correct or not loaded yet - never a stub built from
// the id, which would lack inactiveUser/advisorDetails and read as a disconnected
// client to isClientDisconnected().
export const clientToView = (clientData, viewingClient, clientId) => {
  if (!clientId || (viewingClient && viewingClient._id === clientId)) {
    return undefined;
  }
  return (clientData || []).find(client => client._id === clientId);
};
